import css from './UploadTable.css'
import { on, ready, query, queryAll } from '../../lib/dom.js'
import { ajaxPost, hide, show } from '../../lib/jsfunc.js'
import { post } from '../../lib/ajax.js'
import * as modal from '../../lib/modal.js'

ready(function(){
  checkSubmit();
})

on('click', '.UploadTable .upload', openModal)
on('change', '.Modal.Upload input', onFileChanged)
on('click', ' .Modal.Upload .submit', submitModal)
on('click', '.UploadTable a.delete', deleteUpload)

function openModal(event) {
  event.preventDefault()
  modal.open(this.nextElementSibling)
}

function onFileChanged(event) {
  var file = event.target
  var form = file.closest('form.Modal')
  var upload = query(form, 'a.submit')
  if ( !file.value) {
    upload.classList.add('disabled')
  } else {
    upload.classList.remove('disabled')
  }
}

function submitModal(event) {
  event.preventDefault();
  var form, data;
  if(event.target.matches('.disabled')) return false;
  
  form = event.target.closest('form')
  data = new FormData(form)
  post(form.getAttribute('data-upload-url'), data).then(function(event) {
    var data = JSON.parse(event.target.ajaxResponse);
    if(!data) return false;
    var tr = query('.UploadTable tbody tr[data-context="'+data['upload']+'"]');
    if(tr){
      show(query(tr, 'td div'));
      query(tr, '.Button.delete').classList.remove('disabled');
      checkSubmit();
    }
  })
  modal.close();
}

function deleteUpload(event) {
  event.preventDefault();
  if(event.target.matches('.disabled')) return false;
  
  ajaxPost(event.target.getAttribute('href'), event.target.closest('tr').getAttribute('data-context'),
    function (request){
      var data = JSON.parse(request.responseText);
      if(!data) return false;
      var tr = query('.UploadTable tbody tr[data-context="'+data['delete']+'"]');
      if(tr){
        hide(query(tr, 'td div'));
        query(tr, '.Button.delete').classList.add('disabled');
        checkSubmit();
      }
    }
  );
}

function checkSubmit(){
  if(!query('.application-uploads')) return false;
  
  var docs = queryAll('.application-uploads > .UploadTable > tbody > tr > td > div.mandatory.hidden');
  var button = query('.application-uploads .Buttons .Button.submit');
  
  if(docs.length == 0){
    button.classList.remove('disabled');
  }
  
  if(docs.length>0 && !button.matches('.disabled')){
    button.classList.add('disabled');
  }
}
